import { categories, newsList } from "@/mocks/news";
import type { CategoryItem, NewsItem } from "@/types/news";

export const getCategories = (): CategoryItem[] => categories;

export const getCategoryByKey = (key: string): CategoryItem | undefined =>
  categories.find((c) => c.key === key);

export const getCategoryByName = (name: string): CategoryItem | undefined =>
  categories.find((c) => c.name === name);

export const getFeaturedNews = (): NewsItem[] => newsList.filter((n) => n.featured);

export const getHotNews = (limit = 6): NewsItem[] =>
  [...newsList].sort((a, b) => b.views - a.views).slice(0, limit);

export const getAllNews = (): NewsItem[] => newsList;

export const getNewsById = (id: string): NewsItem | undefined =>
  newsList.find((n) => n.id === id);

export const getNewsByCategory = (categoryName: string): NewsItem[] =>
  newsList.filter((n) => n.category === categoryName);

export const getRelatedNews = (news: NewsItem, limit = 4): NewsItem[] =>
  newsList
    .filter((n) => n.id !== news.id && (n.category === news.category || n.subCategory === news.subCategory))
    .sort((a, b) => b.views - a.views)
    .slice(0, limit);

export const searchNews = (keyword: string): NewsItem[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return newsList.filter(
    (n) =>
      n.title.toLowerCase().includes(kw) ||
      n.summary.toLowerCase().includes(kw) ||
      n.category.toLowerCase().includes(kw) ||
      n.subCategory.toLowerCase().includes(kw) ||
      n.tags.some((t) => t.toLowerCase().includes(kw)),
  );
};

export const formatViews = (views: number): string =>
  views >= 10000 ? `${(views / 10000).toFixed(1)}万` : `${views}`;

export const formatDate = (dateStr: string): string => dateStr.split(" ")[0];

export const formatTimeAgo = (dateStr: string): string => dateStr.split(" ")[1] ?? "";